import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router';
import { Tabs, notification } from 'antd';
import SchoolCard from '../../components/SchoolCard/SchoolCard';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Pagination from '../../components/Pagination/Pagination';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';

const AllSchools = () => {
  const navigate = useNavigate();

  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerView] = useState(9);

  const lastItemIndex = currentPage * itemPerView;
  const firstItemIndex = lastItemIndex - itemPerView;
  const currentItems = schools.slice(firstItemIndex, lastItemIndex);
  let totalNoOfPages = Math.ceil(schools.length / itemPerView);

  // change page function
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  useEffect(() => {
    let token = localStorage.getItem('token');
    scrollToTop();
    const getAllSchools = async () => {
      setLoading(true);
      const res = await fetch(`${baseURL}/schools`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchools(data.data.schools);
      }

      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        localStorage.clear();
        navigate('/login');
      }

      setLoading(false);
    };
    getAllSchools();
  }, []);

  return (
    <div>
      <Helmet>
        <title>PL by Edves | Home</title>
      </Helmet>
      <Header />
      <div className='all-schools'>
        <div className='all-schools__breadcrumbs'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
              fill='#161410'
            />
          </svg>
          <p>
            {' '}
            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              Home
            </span>{' '}
            <span className='all-schools__breadcrumbs__active'>
              | View more schools
            </span>
          </p>
        </div>

        <div
          className='recommended-section__title'
          style={{ marginBottom: '40px' }}
        >
          <h1>Learn from top schools and tutors</h1>
          <p>
            Over 10 schools have uploaded learning <br />
            resources and assessments to help you in your academic journey
          </p>
        </div>
        {/* */}
        <div className='schools-flex'>
          <Tabs defaultActiveKey='1'>
            <Tabs.TabPane tab='Nigeria' key='1'>
              {schools.length === 0 ? (
                loading ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Spinner />
                  </div>
                ) : (
                  <div>No schools found</div>
                )
              ) : (
                <div className='dashboard-body__subject-row'>
                  {currentItems?.map((el, index) => (
                    <SchoolCard
                      key={el.id}
                      schoolLogo={el.logo}
                      schoolHeader={el.logo}
                      schoolName={el.name}
                      subjectNo={el.subject_classes_count}
                      description={el.bio}
                      activities={el.activity_count}
                      location={`${el.state}, ${
                        el.country ? el.country : 'Nigeria'
                      }`}
                      lessonCount={el.lessons_count}
                      selectSchool={() => {
                        navigate(`/schools/${el.link_id ? el.link_id : el.id}`);
                      }}
                      page='dashboard'
                      type='school'
                      index={index}
                    />
                  ))}
                </div>
              )}
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div style={{ marginBottom: '30px' }}>
          <Pagination
            postsPerView={itemPerView}
            totalPosts={schools?.length}
            paginate={paginate}
            currentPage={currentPage}
            totalPages={totalNoOfPages}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AllSchools;
